export enum NotificationTexts {
    RESET_SUCCESS = 'Passwort erfolgreich zurückgesetzt.',
    RESET_ERROR = 'Passwort konnte nicht zurück gesetzt werden.',
    GENERAL_LOGIN_ERROR = 'E-Mail-Adresse oder Passwort fehlerhaft!',
    DEMO_MODE_START = 'Sie werden in ** Minuten automatisch ausgeloggt.'
}
